/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { cloneDeep } from 'lodash';

// Components
import HorizontalDivider from 'shared/ui/components/HorizontalDivider.vue';
import EmailTemplatePicker from 'shared/ui/components/form-components/pickers/EmailTemplatePicker.vue';
import PersonTarget from 'shared/ui/components/form-components/targeting/PersonTarget.vue';

const __vue_script__ = {
    name: 'EmailTargeting',

    components: {
        EmailTemplatePicker,
        HorizontalDivider,
        PersonTarget,
    },

    props: {
        templates: {
            type: Array,
            required: true
        },
        eventId: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: true
        },
        value: {
            type: Object,
            default: () => ({})
        },

    },

    data() {
        return {
            innerValue: cloneDeep(this.value),
            additionalTargetingFields: [{
                label: this.$i18n.t('users.email_modal.invited_targeting'),
                property: '_target_invited_to_event',
                name: '_target_invited_to_event',
                kind: 'boolean',
            }],
        };
    },

    methods: {
        addTargetedEmail() {
            this.innerValue.targeted.push({ template: null, targets: [] });
            this.$refs[`targets_${this.innerValue.targeted.length - 1}`]?.addRule();
            this.$emit('input', this.innerValue);
        },

        removeTargetedEmail(index) {
            this.innerValue.targeted.splice(index, 1);
            this.$emit('input', this.innerValue);
        },

        setDefaultEmail(value) {
            this.$set(this.innerValue, 'default', value);
            this.$emit('input', this.innerValue);
        },

        setTargetedEmail(value, index) {
            this.$set(this.innerValue.targeted[index], 'template', value);
            this.$emit('input', this.innerValue);
        },

        setTargets(value, index) {
            this.$set(this.innerValue.targeted[index], 'targets', value);
            this.$emit('input', this.innerValue);
        },
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"email-targeting"},[_c('p',{staticClass:"email-description"},[_vm._v(_vm._s(_vm.description))]),_c('email-template-picker',{staticClass:"email-template",attrs:{"event-id":_vm.eventId,"show-no-send":true,"name":(_vm.name + "-default"),"label":_vm.$t('registration.configuration.default_email'),"templates":_vm.templates},on:{"input":function (value) { return _vm.setDefaultEmail(value); }},model:{value:(_vm.innerValue.default),callback:function ($$v) {_vm.$set(_vm.innerValue, "default", $$v)},expression:"innerValue.default"}}),_vm._l((_vm.innerValue.targeted),function(targetedEmail,index){return _c('div',{key:("email-template-" + index),staticClass:"email-template"},[_c('email-template-picker',{attrs:{"event-id":_vm.eventId,"name":(_vm.name + "-target" + index),"label":_vm.$t('registration.configuration.email_target_group', [index + 1]),"templates":_vm.templates},on:{"input":function (value) { return _vm.setTargetedEmail(value, index); }},scopedSlots:_vm._u([{key:"after-label",fn:function(ref){return [_c('a',{staticClass:"has-action btn-remove-target",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.removeTargetedEmail(index)}}},[_vm._v(_vm._s(_vm.$t('general.remove')))])]}}],null,true),model:{value:(targetedEmail.template),callback:function ($$v) {_vm.$set(targetedEmail, "template", $$v)},expression:"targetedEmail.template"}}),_c('person-target',{ref:("targets_" + index),refInFor:true,staticClass:"inline",attrs:{"event-id":_vm.eventId,"show-actions":true,"field-kinds":['boolean', 'choice', 'choice-list', 'locale'],"additional-fields":_vm.additionalTargetingFields},on:{"input":function (value) { return _vm.setTargets(value, index); }},scopedSlots:_vm._u([{key:"header",fn:function(ref){return [_c('legend',[_vm._v(_vm._s(_vm.$t('targeting.conditions_editor.emailing.send_to')))])]}}],null,true),model:{value:(targetedEmail.targets),callback:function ($$v) {_vm.$set(targetedEmail, "targets", $$v)},expression:"targetedEmail.targets"}})],1)}),_c('horizontal-divider'),_c('a',{staticClass:"has-action",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.addTargetedEmail.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('registration.configuration.add_targeted_email')))])],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "EmailTargeting.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__